import type { MiddlewareAPI, Middleware, StateFromReducersMapObject } from '@reduxjs/toolkit'
import { combineReducers, configureStore, isRejectedWithValue } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import {
  gusiberiApi,
  authReducer,
  availabilityReducer,
  datesReducer,
  Auth,
  getNavigator,
  probablyBadToken,
  setSharedStore,
  initSharedApiConfig,
  withResetOnLogout,
} from '@gusiberi/shared'
import { uiReducer } from './stores/uiStore'
import { setFeedbackDispatch } from './platform'

const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      const status = (action as any)?.payload?.status
      const data = (action as any)?.payload?.data

      if (
        (status === 401 &&
          (data?.message?.includes('token') || data?.message?.includes('Signature'))) ||
        probablyBadToken((action as any)?.payload)
      ) {
        Auth.logUserOut()
        getNavigator().goToAuth()
      }
    }

    return next(action)
  }

const reducers = {
  [gusiberiApi.reducerPath]: gusiberiApi.reducer,
  schedule: availabilityReducer,
  auth: authReducer,
  ui: uiReducer,
  dates: datesReducer,
}

export type RootState = StateFromReducersMapObject<typeof reducers>

export const store = configureStore({
  reducer: withResetOnLogout(combineReducers(reducers)),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['ui/openConfirmDialog', 'ui/openDialog'],
        ignoredPaths: [
          'ui.confirmationDialogPayload.onConfirmAction',
          'ui.dialogPayload.dialogBody',
          'ui.dialogPayload.onDialogClose',
          'ui.confirmationDialogPayload.onCancelAction',
        ],
      },
    }).concat([gusiberiApi.middleware, rtkQueryErrorLogger]),
})

setupListeners(store.dispatch)

setFeedbackDispatch(store.dispatch)
setSharedStore(store)
initSharedApiConfig()

export type AppDispatch = typeof store.dispatch
